import { Components, Theme } from '@mui/material/styles';

export const modalConfigs: Components<Theme>['MuiModal'] = {
  defaultProps: {
    keepMounted: false,
    slotProps: {
      root: {},
    },
  },
  styleOverrides: {
    root: ({ theme }) => ({
      ':not(MuiPopover-root):not(.MuiMenu-root)': {
        '.MuiModal-backdrop': {
          backgroundColor: theme.palette.grey.overlayOnLight,
        },
      },
      '.MuiPaper-root': {
        ':focus-visible': {
          outline: 'none',
        },
      },
    }),
  },
};
